import React from "react";
import "./Carte.css";
import carte from "../../../images/pc.png";

export default function Carte() {
  return (
    <div className="map-container">
      <h1>Elements Group, au cœur de vos projets dans le monde</h1>
      <p>
        Grâce à notre présence internationale, nous intervenons partout dans le
        monde pour concevoir, réaliser et accompagner vos projets sur mesure.
      </p>

      {/* MAP */}

      <div className="map-wrapper">
        <img src={carte} alt="Carte des réalisations Elements Group en Tunisie, en France et dans le monde" className="cart_img" />
      </div>
    </div>
  );
}
